if (!customElements.get('certifications-modal')) {
  customElements.define(
    'certifications-modal',
    class CertificationsModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
      }

      showActiveMedia(contentID) {
        console.log(contentID);
        const items = document.querySelectorAll('.certifications-modal__item');
        items.forEach(el => el.hidden = true);
        const els = document.querySelectorAll('[data-cert-id="'+contentID+'"]'); // NodeList
        els.forEach(el => {
          // do stuff
          console.log('found', el)
          el.hidden = false;
        });
      }
    }
  );
}
